import { Product } from "../../auction/types"

export enum ItemCardStatus {
    NEW = "new",
    INPROGRESS = "inprogress",
    FAILED = "failed",
    SUCCESS = "success",
    PAUSE = "pause",
}

export enum OTPActions {
    CHANGE_MAIL = "CHANGE_MAIL",
    CONFIRM_CHANGE_MAIL = "CONFIRM_CHANGE_MAIL",
    RESET_PASSWORD = "RESET_PASSWORD",
    LOGIN = "LOGIN"
}

export interface User {
    address?: string,
    createdBy?: string,
    createdDate?: number,
    changePassDate?: number,
    dateOfBirth?: number,
    email?: string,
    fullName?: string,
    modifiedBy?: string,
    modifiedDate?: number,
    phoneNumber?: string,
    roleCodes?: string[],
    sex?: number,
    status?: number,
    statusStr?: string,
    userId?: number,
    userName?: string,
    commune?: Partial<WardResponse>,
    district?: Partial<DistrictResponse>,
    province?: Partial<CityResponse>,
    identificationNumber?: string,
    identificationIssuedBy?: string,
    identificationIssuedDate?: number,
    representativeName?: string,
    businessRegistrationNumber?: string,
    bankId?: number,
    bankAccount?: string,
    bankBranch?: string,
    bankName?: string,
    bankNumber?: string,
    onlineStatus?: boolean,
    representativeProvince?: Partial<CityResponse>,
    representativeDistrict?: Partial<DistrictResponse>,
    representativeCommune?: Partial<WardResponse>,
    representativeEmail?: string,
    representativeAddress?: string,
    representativeIdentificationNumber?: string,
    representativeIdentificationIssuedBy?: string,
    representativeIdentificationIssuedDate?: number,
    representativePhone?: string,
    representativeSex?: number,
    representativeDateOfBirth?: number,
}

export interface UpdateUser {
    address?: string,
    dateOfBirth?: string,
    email?: string,
    fullName?: string,
    phoneNumber?: string,
    sex?: number,
    status?: number,
    communeId?: number,
    districtId?: number,
    provinceId?: number,
    identificationNumber?: string,
    identificationIssuedBy?: string,
    identificationIssuedDate?: string,
    representativeName?: string,
    businessRegistrationNumber?: string,
    bankId?: number,
    bankAccount?: string,
    bankBranch?: string,
    bankName?: string,
    bankNumber?: string,
    representativeProvinceId?: number,
    representativeDistrictId?: number,
    representativeCommuneId?: number,
    representativeEmail?: string,
    representativeAddress?: string,
    representativePhone?: string,
    representativeIdentificationNumber?: string,
    representativeIdentificationIssuedBy?: string,
    representativeIdentificationIssuedDate?: string,
    representativeSex?: number,
    representativeDateOfBirth?: string,
}

export interface WardResponse {
    communeId: number,
    communeName: string,
    communeCode: string,
    isDelete: number,
    status: number,
    district: {
        districtId: number,
        districtName?: string,
        province?: {
            provinceId?: number,
            provinceName?: string
        },
    }
}

export interface DistrictResponse {
    districtId: number,
    districtName: string,
    districtCode: string,
    isDelete: number,
    status: number,
    province: {
        provinceId: number,
        provinceName?: string
    },
}

export interface CityResponse {
    provinceId: number,
    provinceCode: string,
    provinceName: string,
    isDelete: number,
    status: number,
}



export interface WardListResponse {
    content: WardResponse[],
    totalElements: number,
}

export interface SearchWard {
    page: number,
    size: number,
    keyword?: string,
    districtId?: number,
    status?: number,
    provinceId?: number,
}

export interface DistrictListResponse {
    content: DistrictResponse[],
    totalElements: number,
}

export interface SearchDistrict {
    page: number,
    size: number,
    keyword?: string,
    provinceId?: number,
    status?: number,
}

export interface CityListResponse {
    content: CityResponse[],
    totalElements: number,
}

export interface SearchCity {
    page: number,
    size: number,
    keyword?: string,
    status?: number,
}

export interface BankResponse {
    bankId: number,
    bankCode: string,
    bankName: string,
    isDelete: number,
    status: number,
}

export interface BankListResponse {
    content: BankResponse[],
    totalElements: number,
}

export interface SocketMessage {
    type: string,
    sender: string,
    mapProductValue?: {
        [key: string]: {
            productId: number,
            valueOfBid: number,
            startAuctionDate: number,
            endAuctionDate: number,
            createdDate: number,
            bargainSuccess: boolean,
        }
    }
    userId?: number,
    message?: string,
    productId: number,
}
export interface SocketBody {
    type: string,
    sender?: string,
    mapProductValue: {
        [key: string]: {
            productId?: number,
        }
    }
    userId?: number,
    productId?: number,
}

export const registerTypes = {
    NOTREGISTER: -1,    // Chưa nộp hồ sơ
    SUBMIT: 0,          // Đã nộp hồ sơ
    SUCCESS: 1,         // Đăng ký thành công
    DENY: 2,            // Từ chối tham gia
    INVALID: 3          // Đăng ký không hợp lệ
}

export const preCostTypes = {
    NOTPAY: 0,         // Chưa đặt
    WAITING: 1,         // Chờ đối soát
    DONE: 2,            // Đã đối soát
    FAILED: 3,          // Thất bại
}

export const fileTypes = {
    PRODUCT: 12,                // Sản phẩm đấu giá
    BANNER: 13,                 // Ảnh banner
    STATUTE: 14,                // Quy chế
    ACCOUNT: 15,                // Avatar người dùng
    CONTRACT: 16,               // Hợp đồng bán đấu giá
    EVENT: 17,                  // Sự kiện
    PROCEDURE: 18,              // Thủ tục
    REGISTER_AUCTION: 19,       // File đăng ký đấu giá
    STOP_STATUTE_REASON: 20,    // Lý do tạm dừng quy chế đấu giá   
    PAYMENT: 21,                // Biên lai thanh toán tiền đặt trước
    STOP_PRODUCT_REASON: 22,    // Lý do tạm dừng đấu giá sản phẩm
    AUCTION_DECLINE_REASON: 23, // Lý do truất quyền người tham gia đấu giá   
    OTHER_DOCUMENT: 24,         // Tài liệu khác của tài sản thuộc quy chế đã đăng tải
    PRODUCT_REPORT: 25          // Biên bản đấu giá của tài sản thuộc quy chế đã đăng tải
}

export const contractTypes = {
    NOTSUBMIT: 0,               // Chưa tiếp nhận
    PROCESSING: 1,              // Đang xử lý
    SIGNED: 2,                  // Đã ký hợp đồng
    DENY: 3,                    // Không ký hợp đồng
}

export const AuctionTypeCode = {
    NOT_ROUND: "HTDG001",       //Đấu giá không xác định vòng
    HAVE_ROUND: "HTDG002",      //Đấu giá xác định vòng
}

export const AuctionMethodCode = {
    INCREASE: "PTDG001",        // Trả giá lên
    DECREASE: "PTDG002",        //Trả giá xuống
}

export const AuctionDenyTypes = {
    NOT_DENY: 0,                // Không truất quyền
    DENY: 1,                    // Truất quyền
}

export const typeUsername = {
    SO_CMND: 1,
    SO_DKKD: 2,
    PHONE: 3,
    EMAIL: 4,
}

export interface ContractDetail {
    assigne?: User,
    seller: User,
    productName: string,
    mobile?: string,
    status: number,
    products: Product[],
    modifiedDate: number,
    modifiedBy: User,
    createdBy: User,
    createdDate: number,
    contractName?: string,
    contractNumber?: string,
    signDate?: number,
    percentDifference?: number,
    remunerationValue?: number,
    contractId?: number,
    reasonNotSign?: string,
}

export interface CreateContract {
    contractCode?: string,
    productIds?: number[],
    sellerId?: number,
    status?: number,
    contractId?: number,
    contractName?: string,
}

export interface HomeSearchState {
    categoryCodes?: string[],
    title?: string,
    startStatus?: number,
}

export const PropertyTypes = [
    {
        id: 1,
        name: "Tài sản nhà nước theo quy định của pháp luật về quản lý, sử dụng tài sản nhà nước"
    },
    {
        id: 2,
        name: "Tài sản được xác lập quyền sở hữu toàn dân theo quy định của pháp luật"
    },
    {
        id: 3,
        name: "Tài sản là quyền sử dụng đất theo quy định của pháp luật về đất đai"
    },
    {
        id: 4,
        name: "Tài sản bảo đảm theo quy định của pháp luật về giao dịch bảo đảm"
    },
    {
        id: 5,
        name: "Tài sản thi hành án theo quy định của pháp luật về thi hành án dân sự"
    },
    {
        id: 6,
        name: "Tài sản là tang vật, phương tiện vi phạm hành chính bị tịch thu sung quỹ nhà nước, tài sản kê biên để bảo đảm thi hành quyết định xử phạt vi phạm hành chính theo quy định của pháp luật về xử lý vi phạm hành chính"
    },
    {
        id: 7,
        name: "Tài sản là hàng dự trữ quốc gia theo quy định của pháp luật về dự trữ quốc gia"
    },
    {
        id: 8,
        name: "Tài sản cố định của doanh nghiệp theo quy định của pháp luật về quản lý, sử dụng vốn nhà nước đầu tư vào sản xuất, kinh doanh tại doanh nghiệp"
    },
    {
        id: 9,
        name: "Tài sản của doanh nghiệp, hợp tác xã bị tuyên bố phá sản theo quy định của pháp luật về phá sản"
    },
    {
        id: 10,
        name: "Tài sản hạ tầng đường bộ và quyền thu phí sử dụng tài sản hạ tầng đường bộ theo quy định của pháp luật về quản lý, sử dụng và khai thác kết cấu hạ tầng giao thông đường bộ"
    },
    {
        id: 11,
        name: "Tài sản là quyền khai thác khoáng sản theo quy định của pháp luật về khoáng sản"
    },
    {
        id: 12,
        name: "Tài sản là quyền sử dụng, quyền sở hữu rừng sản xuất là rừng trồng theo quy định của pháp luật về bảo vệ và phát triển rừng"
    },
    {
        id: 13,
        name: "Tài sản là quyền sử dụng tần số vô tuyến điện theo quy định của pháp luật về tần số vô tuyến điện"
    },
    {
        id: 14,
        name: "Tài sản là nợ xấu và tài sản bảo đảm của khoản nợ xấu của tổ chức mà Nhà nước sở hữu 100% vốn điều lệ do Chính phủ thành lập để xử lý nợ xấu của tổ chức tín dụng theo quy định của pháp luật"
    },
    {
        id: 15,
        name: "Tài sản khác mà pháp luật quy định phải bán thông qua đấu giá"
    },
    {
        id: 16,
        name: "Tài sản thuộc sở hữu của cá nhân, tổ chức tự nguyện lựa chọn bán thông qua đấu giá"
    }
]